// R-feat-2026-10-17 U4 易用性:网络断开检测
//
// 设计:
//   - useNetworkStatus 监听 navigator.onLine + window.online/offline 事件
//   - 断网恢复后返回 wasOffline=true(consumer 可触发 toast)
//   - 5 秒内可选探测(本 hook 不实现,留给 banner)
//   - 不依赖 service worker,纯浏览器 API
import { useEffect, useState, useCallback } from 'react'

export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  )
  // 上一次切换是否「断→通」,consumer 可用此触发 toast/queue flush
  const [wasOffline, setWasOffline] = useState(false)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      // 只在曾标记 offline 之后才设 wasOffline,避免初始 mount 的 online 事件误报
      if (typeof window !== 'undefined' && window.__pmworkLastOffline) {
        setWasOffline(true)
        window.__pmworkLastOffline = false
      }
    }
    const handleOffline = () => {
      setIsOnline(false)
      if (typeof window !== 'undefined') {
        window.__pmworkLastOffline = true
      }
    }
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  const acknowledgeRecovery = useCallback(() => {
    setWasOffline(false)
  }, [])

  return { isOnline, wasOffline, acknowledgeRecovery }
}
